import {Box, Typography} from '@mui/material';
import {t} from 'i18next';

const NoProtocols = () => {
  return (
    <Box className="no-protocol">
      <Typography
        className="typo-text subhead1_size text-headings"
        data-testid="no-protocols-message"
      >
        {t('ai.review.protocolList.messageNoData')}
      </Typography>
    </Box>
  );
};

export default NoProtocols;
